import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "area-texto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Olá! Sou Marco Antonio.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", null, "Programador Front-End e UI Designer, formado em Análise e Desenvolvimento de Sistemas", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Você pode ver mais dos meus projetos no meu ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "page-home",
    class: _normalizeClass({'bg-page-home-dark': _ctx.darkTheme, 'bg-page-home-light': !_ctx.darkTheme})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("span", null, [
        _hoisted_4,
        _createElementVNode("strong", null, [
          _createElementVNode("a", {
            href: "https://github.com/Marcoantonio9",
            target: "_blank",
            class: _normalizeClass({'link-git-dark': _ctx.darkTheme, 'link-git-light': !_ctx.darkTheme})
          }, "Github", 2)
        ])
      ])
    ])
  ], 2))
}